export default __webpack_public_path__ + "static/media/Database.35dcd21d.jfif";